import { render } from "./RevenueThisMonth.vue?vue&type=template&id=058a9d58&ts=true"
import script from "./RevenueThisMonth.vue?vue&type=script&lang=ts"
export * from "./RevenueThisMonth.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__